import { BlindBindError, type BlindBindErrorCode } from "@wildlark/relay-client"
import type { NestRoute } from "./routes"

export type NestConnectionFailureStage = "device-to-relay" | "relay" | "relay-to-nest" | "device-to-nest"

export interface NestConnectionFailure {
    stage: NestConnectionFailureStage
    routeType: NestRoute["type"]
    code?: BlindBindErrorCode
}

export function classifyNestConnectionFailure(route: NestRoute, error: unknown): NestConnectionFailure {
    if (route.type === "direct") return { stage: "device-to-nest", routeType: "direct" }
    if (!(error instanceof BlindBindError)) return { stage: "device-to-relay", routeType: "relay" }

    if (
        error.code === "offline" ||
        error.code === "host_unavailable" ||
        error.code === "identity_mismatch" ||
        error.code === "handshake_failed" ||
        error.code === "protocol_error"
    ) {
        return { stage: "relay-to-nest", routeType: "relay", code: error.code }
    }
    if (error.code === "busy" || error.code === "rate_limited") {
        return { stage: "relay", routeType: "relay", code: error.code }
    }
    return { stage: "device-to-relay", routeType: "relay", code: error.code }
}
